var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEllipsis = function SvgEllipsis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "4px",
    viewBox: "0 0 18 4",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\xB7\xB7\xB7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Categories---Kinedu-and-custom-Copy-4",
    transform: "translate(-269.000000, -362.000000)",
    fill: "#8295A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder---hover-copy-8",
    transform: "translate(16.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "options-buttons",
    transform: "translate(246.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85691411,10 C9.8426773,10 10.6444561,10.736556 10.7093071,11.7097881 L10.7135413,11.8380326 L10.7053129,12.0350689 C10.6147836,12.9761265 9.81835365,13.6800419 8.85691411,13.6800419 C7.87115092,13.6800419 7.0693721,12.9434859 7.00426859,11.983372 L7,11.8231278 C7,10.8019967 7.82829165,10 8.85691411,10 Z M15.8,10 C16.7857632,10 17.587542,10.736556 17.6523929,11.7097881 L17.6566271,11.8380326 L17.6483988,12.0350689 C17.5578695,12.9761265 16.7614395,13.6800419 15.8,13.6800419 C14.8142368,13.6800419 14.012458,12.9434859 13.9473545,11.983372 L13.9430859,11.8231278 C13.9430859,10.8019967 14.7713775,10 15.8,10 Z M22.7430859,10 C23.6627237,10 24.4313887,10.644036 24.5770238,11.5430148 L24.5929771,11.6671465 L24.6,11.8569141 C24.6,12.8780452 23.7717083,13.6800419 22.7430859,13.6800419 C21.8234481,13.6800419 21.0547831,13.0360059 20.9091479,12.1370271 L20.8931947,12.0128954 L20.8861718,11.8231278 C20.8861718,10.8019967 21.7144634,10 22.7430859,10 Z",
    id: "elipsis-icon"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEllipsis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ellipsis.6b918ddc.svg";
export { ForwardRef as ReactComponent };